import React, { useState, useEffect, useCallback, useRef, useMemo, createContext } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Toast, ToastType } from '../components/common/Toast';

export const ToastContext = createContext<{ addToast: (message: string, type: ToastType) => void } | null>(null);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [toasts, setToasts] = useState<{ id: number; message: string; type: ToastType }[]>([]);
    const toastIdCounter = useRef(0);

    const addToast = useCallback((message: string, type: ToastType) => {
        const id = toastIdCounter.current++;
        setToasts(prev => [...prev, { id, message, type }]);
    }, []);

    const removeToast = useCallback((id: number) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);
    
    const contextValue = useMemo(() => ({ addToast }), [addToast]);

    return (
        <ToastContext.Provider value={contextValue}>
            {children}
            <div className="fixed bottom-5 right-5 z-50 flex flex-col space-y-2">
                <AnimatePresence>
                    {toasts.map(toast => (
                        <Toast key={toast.id} {...toast} onClose={() => removeToast(toast.id)} />
                    ))}
                </AnimatePresence>
            </div>
        </ToastContext.Provider>
    );
}; 